import { TOGGLE_EXPANDED_DETAIL_PANEL } from "./detailsPanelExpandedReducer"

export const toggleExpandedDetailPanel = (value) => ({
    type: TOGGLE_EXPANDED_DETAIL_PANEL,
    payload: value
})